import KendoDateInputMixin from './KendoDateInputMixin'

export default {
    name: 'kendo-dateinput',
    mixins: [ KendoDateInputMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateInput/index.js